import React from "react";
import MultiselectDropdown from "../MultiselectDropdown";
import { categorySteps, locationMapping } from "../../../utils/constant";
import styles from "./index.module.css";
import dateStyles from "../../pages/LiveMonitoring/index.module.css";
import { useState } from "react";
import { Head, Row } from "../TableheadAndRow";
import Calendar from "react-calendar";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllCompetetionTrends,
  fetchAllTimeTrends,
} from "../../../store/slices/analytics/analytics.slice";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { getSource, filterAnalyticsLocationsByOrg } from "../../../utils/helpers";

const formatWebsiteName = (website) => {
  if (website === 'aelia_auckland') {
    return 'auckland_dutyfree';
  }
  return website;
};

// New Zealand sources
const nzSources = [
  "aelia_auckland",
  "aelia_queenstown", 
  "aelia_christchurch"
];

// Australia sources
const auSources = [
  "lotte_melbourne",
  "lotte_brisbane",
  "heinemann_sydney",
  "heinemann_goldcoast",
  "aelia_cairns",
  "aelia_adelaide"
];

// New Zealand domestic players
const nzDomestic = [
  "sephora",
  "beauty_bliss",
  "farmers",
  "nz_liquor",
  "big_barrel",
  "chemist_warehouse",
  "whisky_and_more",
  "mecca",
  "liquorland",
  "lifepharmacy",
];

// Australia domestic players
const auDomestic = [
  "au_chemist_warehouse",
  "au_mecca",
  "au_sephora",
  "the_iconic",
  "danmurphy"
];

// All duty-free locations
const dutyFreelocation = [
  "aelia_auckland",
  "lotte_melbourne",
  "lotte_brisbane",
  "aelia_christchurch",
  "aelia_queenstown",
  "heinemann_sydney",
  "heinemann_goldcoast",
  "aelia_cairns",
  "aelia_adelaide",
  "ishopchangi",
];

// Function to get domestic players based on source country
const getDomesticPlayers = (source) => {
  if (nzSources.includes(source)) {
    return nzDomestic;
  } else if (auSources.includes(source)) {
    return auDomestic;
  }
  return nzDomestic; // default fallback
};

// Function to get type locations based on source
const getTypeLocations = (source) => {
  const domesticPlayers = getDomesticPlayers(source);
  return [
    dutyFreelocation.join(','),
    domesticPlayers.join(',')
  ];
};

const AnalyticsTrends = () => {
  const navigate = useNavigate();
  const [selectedCategories, setSelectedCategories] = useState(categorySteps);
  const [dateToggle, setDateToggle] = useState({
    start: false,
    end: false,
  });
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [value, setValue] = useState({
    startValue: new Date(),
    endValue: new Date(),
  });
  const [timeTrendsData, setTimeTrendsData] = useState([]);

  const dispatch = useDispatch();
  const competetionTrends = useSelector(
    (state) => state.analytics.competetionTrends
  );
  const timeTrends = useSelector((state) => state.analytics.timeTrends);
  const closeCalendar = useSelector((store) => store.toggleDropdown.calendar);
  const { date_range, source } = useSelector((store) => store.constant);
  const organizationId = useSelector((store) => store.user.organizationId);

  const location = useSelector((state) => state.constant.location);

  // Get dynamic locations based on current source
  const currentDomesticPlayers = getDomesticPlayers(source);
  const currentTypeLocations = getTypeLocations(source);
  
  // Debug logging
  console.log('Current source:', source);
  console.log('Current domestic players:', currentDomesticPlayers);
  console.log('Current type locations:', currentTypeLocations);

  // Utility function to format dates
  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    const brand = {
      latest: {},
      past: {},
    };

    const product = {
      latest: {},
      past: {},
    };

    const tableData = [];

    for (let i = 0; i < timeTrends?.brands?.latest?.data.length; i++) {
      if (!brand.latest[timeTrends?.brands?.latest?.data[i]?.category])
        brand.latest[timeTrends?.brands?.latest?.data[i]?.category] = [
          timeTrends?.brands?.latest?.data[i],
        ];
      else
        brand.latest[timeTrends?.brands?.latest?.data[i]?.category]?.push(
          timeTrends?.brands?.latest?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.brands?.past?.data.length; i++) {
      if (!brand.past[timeTrends?.brands?.past?.data[i]?.category])
        brand.past[timeTrends?.brands?.past?.data[i]?.category] = [
          timeTrends?.brands?.past?.data[i],
        ];
      else
        brand.past[timeTrends?.brands?.past?.data[i]?.category]?.push(
          timeTrends?.brands?.past?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.products?.latest?.data.length; i++) {
      if (!product.latest[timeTrends?.products?.latest?.data[i]?.category])
        product.latest[timeTrends?.products?.latest?.data[i]?.category] = [
          timeTrends?.products?.latest?.data[i],
        ];
      else
        product.latest[timeTrends?.products?.latest?.data[i]?.category]?.push(
          timeTrends?.products?.latest?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.products?.past?.data.length; i++) {
      if (!product.past[timeTrends?.products?.past?.data[i]?.category])
        product.past[timeTrends?.products?.past?.data[i]?.category] = [
          timeTrends?.products?.past?.data[i],
        ];
      else
        product.past[timeTrends?.products?.past?.data[i]?.category]?.push(
          timeTrends?.products?.past?.data[i]
        );
    }

    let pc = 0,
      bc = 0,
      ppc = 0,
      bbc = 0;

    for (let i = 0; i < Object.keys(product?.latest)?.length; i++) {
      let latest = timeTrends?.priceranks?.latest?.find(
        (el) => el?.category == Object.keys(product?.latest)[i]
      );
      let past = timeTrends?.priceranks?.past?.find(
        (el) => el?.category == Object.keys(product?.latest)[i]
      );

      pc += product?.latest[Object.keys(product?.latest)[i]]?.length;
      bc += brand?.latest[Object.keys(product?.latest)[i]]?.length;
      ppc +=
        product?.latest[Object.keys(product?.latest)[i]]?.length -
        product?.past[Object.keys(product?.latest)[i]]?.length;
      bbc +=
        brand?.latest[Object.keys(product?.latest)[i]]?.length -
        brand?.past[Object.keys(product?.latest)[i]]?.length;
      tableData?.push({
        category: Object.keys(product?.latest)[i],
        product_count: product?.latest[Object.keys(product?.latest)[i]]?.length,
        product_count_chg:
          product?.latest[Object.keys(product?.latest)[i]]?.length -
          product?.past[Object.keys(product?.latest)[i]]?.length,
        brand_count: brand?.latest[Object.keys(product?.latest)[i]]?.length,
        brand_count_chg:
          brand?.latest[Object.keys(product?.latest)[i]]?.length -
          brand?.past[Object.keys(product?.latest)[i]]?.length,
      });
    }

    tableData?.push({
      category: "all",
      product_count: pc,
      brand_count: bc,
      product_count_chg: ppc,
      brand_count_chg: bbc,
    });

    setTimeTrendsData(tableData);
  }, [timeTrends]);

  useEffect(() => {
    // Initialize dateRange with today's date
    const past = new Date(date_range?.min_date);
    const latest = new Date(date_range?.max_date);

    setDateRange({ start: formatDate(past), end: formatDate(latest) });
  }, [date_range]);

  useEffect(() => {
    setDateToggle({ start: false, end: false });
  }, [closeCalendar]);

  useEffect(() => {
    dispatch(
      fetchAllCompetetionTrends({
        selectedCategories,
        source,
        domesticPlayers: currentDomesticPlayers,
        organizationId,
      })
    );
  }, [selectedCategories, source, currentDomesticPlayers, organizationId]);

  useEffect(() => {
    if (dateRange.start && dateRange.end) {
      dispatch(
        fetchAllTimeTrends({
          past_date: dateRange.start,
          latest_date: dateRange.end,
          source,
        })
      );
    }
  }, [dateRange]);

  const handleDateRange = (selectedDate) => {
    const formattedDate = formatDate(selectedDate);

    if (dateToggle.start) {
      setValue({ ...value, startValue: selectedDate });
      setDateRange({ ...dateRange, start: formattedDate });
    }

    if (dateToggle.end) {
      setValue({ ...value, endValue: selectedDate });
      setDateRange({ ...dateRange, end: formattedDate });
    }

    setDateToggle({ start: false, end: false });
  };

  const toggleCalendar = (type) => {
    setDateToggle((prev) => ({
      start: type === "start" ? !prev.start : false,
      end: type === "end" ? !prev.end : false,
    }));
  };

  const onSelectedCategoryChange = (value) => {
    setSelectedCategories(value);
  };

  const timeTrendsdata = {
    data: [
      {
        price: "2/4",
        chg1: {
          value: 1,
          status: "down",
        },
        category: "Liquor",
        brands: "7",
        chg2: {
          value: null,
          status: "",
        },
        products: "9",
        chg3: {
          value: 4,
          status: "up",
        },
      },
      {
        price: "1/4",
        chg1: {
          value: 1,
          status: "up",
        },
        category: "Beauty",
        brands: "4",
        chg2: {
          value: 2,
          status: "up",
        },
        products: "5",
        chg3: {
          value: 4,
          status: "up",
        },
      },
      // {
      //   price: "2/4",
      //   chg1: {
      //     value: null,
      //     status: "",
      //   },
      //   category: "Apparel",
      //   brands: "7",
      //   chg2: {
      //     value: 1,
      //     status: "down",
      //   },
      //   products: "14",
      //   chg3: {
      //     value: 5,
      //     status: "down",
      //   },
      // },
      {
        price: "2/4",
        chg1: {
          value: 1,
          status: "down",
        },
        category: "All",
        brands: "11",
        chg2: {
          value: 1,
          status: "up",
        },
        products: "14",
        chg3: {
          value: 8,
          status: "up",
        },
      },
    ],
  };

  return (
    <div className={styles["container"]}>
      {/* Heading and categroies selection. */}
      <div className={styles["heading"]}>
        <div>
          <h3>Competition Trends</h3>
          <span>
            See how you compare to other airports and your domestic market.
          </span>
        </div>
        <div className={styles["filter"]}>
          <div>
            <div>Category</div>
            <div>
              <i class="bi bi-columns-gap"></i>
            </div>
          </div>
          <div className={styles["dropdown"]}>
            <MultiselectDropdown
              steps={categorySteps}
              onChange={onSelectedCategoryChange}
              name=""
            />
          </div>
        </div>
      </div>

      {/* table */}
      <div className={styles["categoryTable"]}>
        <Head>
          <span>Location</span>
          <span>Products</span>
          <span>Cheapest</span>
          <span>Midrange</span>
          <span>Expensive</span>
        </Head>
        {Object.keys(competetionTrends).length === 0 ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          (() => {
            // Check if all items in typeComparision have 0 values
            const allZero = competetionTrends?.typeComparision?.every(item => 
              item.product_count === 0 && 
              item.cheapest_count === 0 && 
              item.midrange_count === 0 && 
              item.expensive_count === 0
            );
            
            if (allZero) {
              return (
                <div className={styles["no-data"]}>
                  <span>No comparisons</span>
                </div>
              );
            }
            
            // Sort by percentage of cheapest products (high to low)
            const sortedTypeComparison = [...competetionTrends?.typeComparision].sort((a, b) => {
              const totalA = a.product_count || 0;
              const totalB = b.product_count || 0;
              const percentageA = totalA > 0 ? (a.cheapest_count || 0) / totalA * 100 : 0;
              const percentageB = totalB > 0 ? (b.cheapest_count || 0) / totalB * 100 : 0;
              return percentageB - percentageA; // Descending order
            });
            
            return sortedTypeComparison?.map((item, index) => (
              <Row
                key={index}
                islast={
                  sortedTypeComparison?.length - 1 == index
                    ? true
                    : false
                }
              >
                <span>{item.website_type}</span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?category=${selectedCategories}&location=${currentTypeLocations[index]}`
                    )
                  }
                >
                  {item.product_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=cheapest&category=${selectedCategories}&location=${currentTypeLocations[index]}`
                    )
                  }
                >
                  {item.cheapest_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=midrange&category=${selectedCategories}&location=${currentTypeLocations[index]}`
                    )
                  }
                >
                  {item.midrange_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=expensive&category=${selectedCategories}&location=${currentTypeLocations[index]}`
                    )
                  }
                >
                  {item.expensive_count}
                </span>
              </Row>
            ));
          })()
        )}
      </div>

      <div
        className={styles["categoryTable"]}
        style={{
          marginTop: "calc(4.5 * var(--base-y))",
          marginBottom: "calc(7.6 * var(--base-y)",
        }}
      >
        <Head>
          <span>Location</span>
          <span>Products</span>
          <span>Cheapest</span>
          <span>Midrange</span>
          <span>Expensive</span>
        </Head>
                {Object.keys(competetionTrends).length === 0 || !competetionTrends?.dutyFreeLocationComparision ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          (() => {
            const dutyFreeLocationsFromMapping = filterAnalyticsLocationsByOrg(
              Object.keys(locationMapping).filter(
                (item) => locationMapping[item].type === "Duty Free"
              ),
              organizationId
            );
            
            const filteredDutyFree = competetionTrends?.dutyFreeLocationComparision
              ?.filter((i) => 
                i.website !== source && 
                dutyFreeLocationsFromMapping.includes(i.website)
              );
            
            // Sort by percentage of cheapest products (high to low)
            const sortedDutyFree = [...filteredDutyFree].sort((a, b) => {
              const totalA = a.product_count || 0;
              const totalB = b.product_count || 0;
              const percentageA = totalA > 0 ? (a.cheapest_count || 0) / totalA * 100 : 0;
              const percentageB = totalB > 0 ? (b.cheapest_count || 0) / totalB * 100 : 0;
              return percentageB - percentageA; // Descending order
            });
            
            // Check if all filtered duty-free items have 0 values
            const allZero = sortedDutyFree?.every(item => 
              item.product_count === 0 && 
              item.cheapest_count === 0 && 
              item.midrange_count === 0 && 
              item.expensive_count === 0
            );
            
            if (allZero || !sortedDutyFree?.length) {
              return (
                <div className={styles["no-data"]}>
                  <span>No duty free comparisons</span>
                </div>
              );
            }
            
            return sortedDutyFree?.map((item, index) => (
              <Row
                key={index}
                islast={
                  sortedDutyFree?.length - 1 == index
                    ? true
                    : false
                }
              >
                <span>{formatWebsiteName(item.website)}</span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.product_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=cheapest&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.cheapest_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=midrange&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.midrange_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=expensive&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.expensive_count}
                </span>
              </Row>
            ));
          })()
        )}
      </div>

      <div
        className={styles["categoryTable"]}
        style={{
          marginTop: "calc(4.5 * var(--base-y))",
          marginBottom: "calc(7.6 * var(--base-y)",
        }}
      >
        <Head>
          <span>Location</span>
          <span>Products</span>
          <span>Cheapest</span>
          <span>Midrange</span>
          <span>Expensive</span>
        </Head>
        {Object.keys(competetionTrends).length === 0 || !competetionTrends?.domesticLocationComparison ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          (() => {
            const filteredDomestic = competetionTrends?.domesticLocationComparison
              ?.filter(item => currentDomesticPlayers.includes(item.website));
            
            // Sort by percentage of cheapest products (high to low)
            const sortedDomestic = [...filteredDomestic].sort((a, b) => {
              const totalA = a.product_count || 0;
              const totalB = b.product_count || 0;
              const percentageA = totalA > 0 ? (a.cheapest_count || 0) / totalA * 100 : 0;
              const percentageB = totalB > 0 ? (b.cheapest_count || 0) / totalB * 100 : 0;
              return percentageB - percentageA; // Descending order
            });
            
            // Check if all filtered domestic items have 0 values
            const allZero = sortedDomestic?.every(item => 
              item.product_count === 0 && 
              item.cheapest_count === 0 && 
              item.midrange_count === 0 && 
              item.expensive_count === 0
            );
            
            if (allZero || !sortedDomestic?.length) {
              return (
                <div className={styles["no-data"]}>
                  <span>No domestic comparisons</span>
                </div>
              );
            }
            
            return sortedDomestic?.map((item, index) => (
              <Row
                key={index}
                islast={
                  sortedDomestic?.length - 1 == index
                    ? true
                    : false
                }
              >
                <span>{formatWebsiteName(item.website)}</span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.product_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=cheapest&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.cheapest_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=midrange&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.midrange_count}
                </span>
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?pricerange=expensive&category=${selectedCategories}&location=${source},${item.website}`
                    )
                  }
                >
                  {item.expensive_count}
                </span>
              </Row>
            ));
          })()
        )}
      </div>

      {/* Time trends */}
      {/* <div className={styles["heading"]} style={{}}>
        <div>
          <h3>Time Trends</h3>
          <span>Track how your stats change over time.</span>
        </div>

        <div className={styles["dateRange"]}>
          <span>Date Range</span>
          <div className={styles["dates"]}>
            <div
              className={styles["start"]}
              onClick={(e) => {
                e.stopPropagation();
                setDateToggle({ start: !dateToggle.start, end: false });
              }}
            >
              <input type="text" defaultValue={dateRange.start} readOnly />
              <i class="bi bi-calendar-date"></i>
            </div>
            <div
              className={styles["end"]}
              onClick={(e) => {
                e.stopPropagation();
                setDateToggle({ start: false, end: !dateToggle.end });
              }}
            >
              <input type="text" defaultValue={dateRange.end} readOnly />
              <i class="bi bi-calendar-date"></i>
            </div>
          </div>
          {dateToggle.start && (
            <div
              className={styles["calendar"]}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                value={value.startValue}
                onChange={(e) => handleDateRange(e)}
              />
            </div>
          )}

          {dateToggle.end && (
            <div
              className={styles["calendar"]}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                value={value.endValue}
                onChange={(e) => handleDateRange(e)}
              />
            </div>
          )}
        </div>
      </div> */}

      {/* <div className={styles["categoryTable"]}>
        <Head>
          <span>Category</span>
          <span>Brands</span>
          <span>Chg</span>
          <span>Products</span>
          <span>Chg</span>
        </Head>
        {timeTrendsData?.map((item,index)=>
          <Row
            key={index}
            islast={timeTrendsData?.length - 1 == index ? true : false}
          >
            <span>{item.category}</span>
            <span>{item.brand_count}</span>
            <span>
              {Math.abs(item.brand_count_chg || 0)}{" "}
              {item.brand_count_chg!==null &&
                ((item.brand_count_chg>0) == "up" ? (
                  <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${styles["down"]}`}></i>
                ))}
            </span>
            <span>{item.product_count}</span>
            <span>
              {Math.abs(item.product_count_chg || 0)}{" "}
              {item.product_count_chg!==null &&
                ((item.product_count_chg>0) == "up" ? (
                  <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${styles["down"]}`}></i>
                ))}
            </span>
          </Row>
        )} */}
      {/* {timeTrendsdata?.data?.map((item, index) => (
          <Row
            key={index}
            islast={timeTrendsdata?.data?.length - 1 == index ? true : false}
          >
            <span>{index!==timeTrendsdata?.data?.length?item.price:"-"}</span>
            {index!==timeTrendsdata?.data?.length?<span>
              {item.chg1.value || "-"}{" "}
              {item.chg1.value &&
                (item.chg1.status == "up" ? (
                  <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${styles["down"]}`}></i>
                ))}
            </span>:<span>{"-"}</span>}
            <span>{item.category}</span>
            <span>{item.brands}</span>
            <span>
              {item.chg2.value || "-"}{" "}
              {item.chg2.value &&
                (item.chg2.status == "up" ? (
                  <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${styles["down"]}`}></i>
                ))}
            </span>
            <span>{item.products}</span>
            <span>
              {item.chg3.value || "-"}{" "}
              {item.chg3.value &&
                (item.chg3.status == "up" ? (
                  <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${styles["down"]}`}></i>
                ))}
            </span>
          </Row>
        ))} */}
      {/* </div> */}
    </div>
  );
};

export default AnalyticsTrends;
